import React from 'react'
import { Bar } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    BarElement,
    BarController,
    CategoryScale,
    LinearScale,
    Tooltip,
} from 'chart.js'
import Utils from 'common/Utils'
import Colors from 'common/utils/Colors'
import { AmountByTag } from 'types'

ChartJS.register(BarElement, BarController, CategoryScale, LinearScale, Tooltip)

interface Props {
    data: Record<string, AmountByTag[]>
}

function ExpenseByTagBarChart({ data }: Props) {
    const currencies = Object.keys(data)
    return <>
        {currencies.map(curr => {
            const entries = [...(data[curr] ?? [])].sort(
                (a, b) => Math.abs(Number(b.amount)) - Math.abs(Number(a.amount))
            )
            const chartData = {
                labels: entries.map(e => e.tag ? e.tag.name : 'Untagged'),
                datasets: [{
                    data: entries.map(e => Math.abs(Number(e.amount))),
                    backgroundColor: entries.map(e => Colors.bySign(e.amount)),
                    borderWidth: 1,
                }],
            }
            return <div key={curr} style={{ marginBottom: '1em' }}>
                <Bar
                    data={chartData}
                    options={{
                        indexAxis: 'x',
                        responsive: true,
                        plugins: {
                            title: {
                                display: true,
                                text: curr,
                            },
                            tooltip: {
                                callbacks: {
                                    label: (context: any) => {
                                        const entry = entries[context.dataIndex]
                                        return ` ${Utils.formatMoney(entry.amount)} ${curr}`
                                    }
                                }
                            },
                            legend: { display: false },
                        },
                        scales: {
                            x: { ticks: { autoSkip: false } },
                            y: { display: false },
                        },
                    } as any}
                />
            </div>
        })}
    </>
}

export default ExpenseByTagBarChart
